import React, { Component } from 'react';
import Cookies from 'js-cookie';
import { PageContext } from '@content/types/pageContext';
import MetaGlobal from '@components/common/MetaGlobal';
import LayoutWrapper from './layout';
import { LocationDependent } from '@content/types/general';
import languages from '@content/json/languages.json';
import * as utils from '@utils';

/* fixes hash links */
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('smooth-scroll')('a[href*="#"]', {
    speed: 300,
    speedAsDuration: true,
    easing: 'easeOutQuad',
  });
}

interface GlobalLayoutProps extends LocationDependent {
  path: string;
  pageContext: PageContext;
}

class IndexLayout extends Component<GlobalLayoutProps> {
  state = {
    loaded: false,
    cookieBannerOpened: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loaded: true });
    }, 100);

    setTimeout(this.checkCookie, 600);
    this.checkLang();
  }

  checkCookie = () => {
    if (Cookies.get('ipos-cookies')) {
      this.setState({ cookieBannerOpened: false });
    } else {
      this.setState({ cookieBannerOpened: true });
    }
  };

  checkLang = () => {
    const cookieLang = Cookies.get('ipos-language')
      ? Cookies.get('ipos-language')
      : languages.default;

    if (
      this.props.pageContext.langcode &&
      cookieLang !== this.props.pageContext.langcode &&
      typeof window !== 'undefined'
    ) {
      window.location.href = utils.langLink(
        cookieLang,
        this.props.pageContext.otherLangUrl[cookieLang]
      );
    }
  };

  acceptCookies = () => {
    Cookies.set('ipos-cookies', true, { expires: 365 });
    this.setState({ cookieBannerOpened: false });
  };

  closeCookieBanner = () => this.setState({ cookieBannerOpened: false });

  render() {
    return (
      <>
        <MetaGlobal />
        <LayoutWrapper
          {...this.props}
          opened={this.state.cookieBannerOpened}
          acceptCookies={this.acceptCookies}
          closeCookieBanner={this.closeCookieBanner}
        />
      </>
    );
  }
}

export default IndexLayout;
